module.exports = __webpack_public_path__ + "img/g.abcd4fba.png";